import { http } from 'api';

export const addMediaApi = (body) => http.post('media', body);
